import {Component} from 'react';
import Swal from 'sweetalert2';

import http from 'services/http';
import axios from 'axios';
import {alerta} from "../../../../components/Alert";
import {moedaInput, moedaDisplay, parseMoeda} from '../../../../utils/moedaInput';
import VinculoGerenteLoteria from '../../../../components/VinculoGerenteLoteria';
import LimitesBloqueioLoteria from '../../../../components/LimitesBloqueioLoteria';

export default class Editar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            abaAtiva: 'dados',
            nome: '',
            hora: '',
            quantidadeSorteio: '',
            milharMoto: '0',
            maximo_premio: '',
            cotas_premio: '',
            listaCotacoes: [],
            listaLoterias: [],
            loteria_central: '',
            loteria_instantanea: 0,
            loteria_federal: false,
            carregaPost: false,
            semana: [
                {
                    dia: 'Segunda',
                    ativo: false,
                },
                {
                    dia: 'Terça',
                    ativo: false,
                },
                {
                    dia: 'Quarta',
                    ativo: false,
                },
                {
                    dia: 'Quinta',
                    ativo: false,
                },
                {
                    dia: 'Sexta',
                    ativo: false,
                },
                {
                    dia: 'Sábado',
                    ativo: false,
                },
                {
                    dia: 'Domingo',
                    ativo: false,
                },
            ],
        };
    }


    componentDidMount = async () => {
        try {
            const {id} = this.props.match.params;

            const response = await http.get(`/loterias/${id}`);

            const {data: loteria} = response.data;

            this.requestLoteriasCentral();
            this.requestCotacoes();

            this.setState((state, props) => ({
                nome: loteria.nome,
                hora: loteria.hora,
                modalidade: loteria.modalidade,
                quantidadeSorteio: loteria.quantidade_sorteios,
                milharMoto: loteria.milhar_moto,
                maximo_premio: loteria.maximo_premio ? moedaDisplay(loteria.maximo_premio) : '',
                cotas_premio: loteria.cotas_premio || '',
                loteria_central: loteria.central_id,
                loteria_instantanea: loteria.loteria_instantanea,
                loteria_federal: loteria.loteria_federal || false,
                semana: [
                    {
                        dia: 'Segunda',
                        ativo: loteria.segunda,
                    },
                    {
                        dia: 'Terça',
                        ativo: loteria.terca,
                    },
                    {
                        dia: 'Quarta',
                        ativo: loteria.quarta,
                    },
                    {
                        dia: 'Quinta',
                        ativo: loteria.quinta,
                    },
                    {
                        dia: 'Sexta',
                        ativo: loteria.sexta,
                    },
                    {
                        dia: 'Sábado',
                        ativo: loteria.sabado,
                    },
                    {
                        dia: 'Domingo',
                        ativo: loteria.domingo,
                    },
                ],
            }));
        } catch (e) {
            alerta(e.response.data);

            return this.props.history.push('/extracao');
        }
    };

    requestLoteriasCentral = async () => {
        try {
            const response = await axios.get('https://centralsete.com/api/loterias');

            const loterias_central = response.data.loterias;

            this.setState({listaLoterias: loterias_central});
        } catch (e) {
            alerta(e.response.data);
        }
    };

    requestCotacoes = async () => {
        try {
            const response = await http.get('bancas/titulo-cotacoes');
            this.setState({listaCotacoes: response.data.data || []});
        } catch (e) {
        }
    };

    salvarEdicoes = async () => {
        try {
            this.setState({carregaPost: true});
            const {
                nome, 
                hora, 
                semana, 
                quantidadeSorteio, 
                milharMoto, 
                maximo_premio,
                cotas_premio,
                loteria_central, 
                modalidade
            } = this.state;
            const {id} = this.props.match.params;

            const res = await http.put(`/loterias/${id}`, {
                nome: nome,
                hora: hora,
                modalidade: 'tradicional',
                segunda: semana[0].ativo,
                terca: semana[1].ativo,
                quarta: semana[2].ativo,
                quinta: semana[3].ativo,
                sexta: semana[4].ativo,
                sabado: semana[5].ativo,
                domingo: semana[6].ativo,
                quantidade_sorteios: quantidadeSorteio,
                milhar_moto: milharMoto,
                maximo_premio: maximo_premio ? parseMoeda(maximo_premio) : null,
                cotas_premio: cotas_premio || null,
                central_id: loteria_central,
            });

            alerta(res.data);

            this.props.history.push('/extracao');
        } catch (e) {
            alerta(e.response.data);

            this.setState({carregaPost: false});
        }
    };

    perguntarParaApagar = () => {
        Swal.fire({
            title: 'Deseja apagar a extração?',
            text: 'Todas as apostas serão apagadas junto a extração!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
            confirmButtonText: 'Sim, apagar!',
            cancelButtonText: 'Não, cancelar',
        }).then((result) => {
            if (result.value) {
                this.deleteExtracao();
            }
        });
    };

    deleteExtracao = async () => {
        try {
            const {id} = this.props.match.params;
            const {data} = await http.delete(`/loterias/${id}`);

            alerta(data);

            this.props.history.push('/extracao');
        } catch (e) {
            alerta(e.response.data);
        }
    };

    changerCheckBox = (dia, index) => {
        const {semana} = this.state;
        semana[index].ativo = !dia.ativo;

        this.setState({semana});
    };

    renderCheckBox = () => {
        return this.state.semana.map((item, index) => {
            return (
                <label key={index} className='control-label' style={{marginRight: '15px'}}>
                    <input
                        type='checkbox'
                        checked={item.ativo}
                        onChange={() => {
                            this.changerCheckBox(item, index);
                        }}
                    />
                    &nbsp;
                    {item.dia}
                </label>
            );
        });
    };

    formatarMoeda = (valor) => {
        if (!valor) return '';
        
        const numero = valor.toString().replace(/\D/g, '');
        
        const decimal = (parseFloat(numero) / 100).toFixed(2);
        
        return decimal;
    };

    exibirValorFormatado = (valor) => {
        if (!valor) return '';
        
        return parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    render() {
        return (
            <div className="bordered">
                <div>
                    <div className='titulo-principal'>Editar Loteria</div>

                    <div style={{display: 'flex', gap: 4, padding: '8px 10px 0', borderBottom: '1px solid #ddd'}}>
                        <button
                            type="button"
                            className={`btn btn-sm ${this.state.abaAtiva === 'dados' ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => this.setState({abaAtiva: 'dados'})}
                        >
                            Dados
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${this.state.abaAtiva === 'gerentes' ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => this.setState({abaAtiva: 'gerentes'})}
                        >
                            Gerentes
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${this.state.abaAtiva === 'bloquear' ? 'btn-primary' : 'btn-light'}`}
                            onClick={() => this.setState({abaAtiva: 'bloquear'})}
                        >
                            Bloquear
                        </button>
                    </div>

                    {this.state.abaAtiva === 'gerentes' && (
                        <VinculoGerenteLoteria tipo="loteria" id={parseInt(this.props.match.params.id)} />
                    )}

                    {this.state.abaAtiva === 'bloquear' && (
                        <LimitesBloqueioLoteria id={parseInt(this.props.match.params.id)} />
                    )}

                    {this.state.abaAtiva === 'dados' && (<>
                    <div className="btn-group caixa-inputs p-b">
                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Nome da loteria:</label>
                            <input
                                onChange={(c) => this.setState({nome: c.target.value})}
                                disabled={this.state.loteria_instantanea}
                                type='text'
                                className='form-control input-dados-criar'
                                value={this.state.nome}
                            />
                        </div>

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Encerra:</label>
                            <input
                                onChange={(c) =>
                                    this.setState({hora: c.target.value + ':00'})
                                }
                                type='time'
                                className='form-control input-dados-criar'
                                value={this.state.hora.slice(0, 5)}
                            />
                        </div>

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Sorteios:</label>
                            <select
                                className='form-control input-dados-criar'
                                value={this.state.quantidadeSorteio}
                                onChange={(e) =>
                                    this.setState({quantidadeSorteio: e.target.value})
                                }
                            >
                                <option value='5'>1a5</option>
                                <option value='7'>1a7</option>
                                <option value='10'>1a10</option>
                            </select>
                        </div>

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Loteria Federal:</label>
                            <input
                                type='text'
                                className='form-control input-dados-criar'
                                value={this.state.loteria_federal ? 'Sim' : 'Não'}
                                disabled
                                style={{
                                    backgroundColor: this.state.loteria_federal ? '#d4edda' : '#f8d7da',
                                    color: this.state.loteria_federal ? '#155724' : '#721c24',
                                    fontWeight: 'bold',
                                    cursor: 'not-allowed'
                                }}
                            />
                        </div>

                        {/* <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Modalidade:</label>
                            <select
                                className='form-control input-dados-criar'
                                value={this.state.modalidade}
                                onChange={(e) =>
                                    this.setState({modalidade: e.target.value})
                                }
                            >
                                <option value='tradicional'>Tradicional</option>
                            </select>
                        </div> */}

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>
                                Máx. Prêmios:
                            </label>
                            <input
                                onChange={(e) => this.setState({maximo_premio: moedaInput(e.target.value)})}
                                type='text'
                                inputMode='numeric'
                                className='form-control input-dados-criar'
                                value={this.state.maximo_premio}
                                placeholder='0,00'
                            />
                        </div>

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>
                                Cotação p/ cálculo:
                            </label>
                            <select
                                className='form-control input-dados-criar'
                                onChange={(e) => this.setState({cotas_premio: e.target.value})}
                                value={this.state.cotas_premio}
                            >
                                <option value=''>Selecione a cotação</option>
                                {this.state.listaCotacoes.map((c) => (
                                    <option key={c.id} value={c.id}>
                                        {c.nome}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {!this.state.loteria_instantanea && (
                            <div className='input-criacao-usuario margin-vertical-30'>
                                <label className='titulo-input-criacao'>Central:</label>
                                <select
                                    className='form-control input-dados-criar'
                                    onChange={(e) =>
                                        this.setState({loteria_central: e.target.value})
                                    }
                                    value={this.state.loteria_central || ''}
                                >
                                    <option value="">Selecione uma central</option>
                                    {this.state.listaLoterias.map(u => (
                                        <option key={u.loteria_id} value={u.loteria_id}>
                                            {u.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <div className='input-criacao-usuario margin-vertical-30'>
                            <label className='titulo-input-criacao'>Dias da semana:</label>
                            <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                                {this.renderCheckBox()}
                            </div>
                        </div>
                    </div>

                    {this.state.loteria_instantanea ? (
                        <div
                            style={{
                                padding: "0 10px",
                                justifyContent: "left",
                            }}
                            className="d-flex m-b m-t"
                        >
                            <button
                                style={{
                                    display: "block",
                                    width: "270px",
                                    marginLeft: "150px",
                                }}
                                className='btn btn-success'
                                onClick={() => this.salvarEdicoes()}
                                disabled={this.state.carregaPost}
                            >
                                Salvar
                            </button>
                        </div>
                    ) : (
                        <div
                            style={{
                                padding: "0 10px",
                                justifyContent: "left",
                                gap: "10px"
                            }}
                            className="d-flex m-b m-t"
                        >
                            {!this.state.loteria_federal && (
                                <button
                                    style={{
                                        display: "block",
                                        width: "270px",
                                        marginLeft: "150px",
                                    }}
                                    className='btn btn-warning'
                                    onClick={() => this.perguntarParaApagar()}
                                >
                                    Excluir
                                </button>
                            )}
                            <button
                                style={{
                                    display: "block",
                                    width: "270px",
                                    marginLeft: this.state.loteria_federal ? "150px" : "0",
                                }}
                                className='btn btn-success'
                                onClick={() => this.salvarEdicoes()}
                                disabled={this.state.carregaPost}
                            >
                                Salvar
                            </button>
                        </div>
                    )}
                    </>)}
                </div>
            </div>
        );
    }
}